import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FinanceiroService } from '../../../../services/financeiro.service';
import { TipoContaEnum } from '../../../../../../core/enums/tipo-conta.enum';
import { NovaConta } from '../../../models/nova-conta';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../auth/services/auth-service';
import { BaixarConta } from '../../../models/baixar-conta';

@Component({
  selector: 'app-financeiro-contas-pagar',
  templateUrl: './financeiro-contas-pagar.component.html',
  styleUrls: ['./financeiro-contas-pagar.component.css'],
  standalone: false
})
export class FinanceiroContasPagarComponent implements OnInit {
  @Input() pessoas: any = { itens: [] };

  contasAPagar: any[] = [];

  contasAgrupadas: any[] = [];
  modalNovaConta = false;
  modalPagarConta = false;
  modalDeletarConta = false;

  novaConta: NovaConta = {
    descricao: '',
    valor: 0,
    dataVencimento: '',
    tipoConta: 1,
    categoria: 0
  };

  pagamento: any = {
    dataPagamento: '',
    valor: 0,
    conta: null
  };

  contaParaDeletar: any = null;

  constructor(
    private financeiroService: FinanceiroService,
    private toastr: ToastrService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.carregarContas();
  }

  carregarContas() {
    this.financeiroService.obterContasAPagar().subscribe(response => {
      if (response.sucesso && Array.isArray(response.dados)) {
        this.contasAPagar = response.dados;
        this.agruparContas();
      }
    });
  }

  agruparContas() {
    this.contasAgrupadas = this.processarAgrupamento(this.contasAPagar);
  }

  processarAgrupamento(contas: any[]) {
    const meses = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const agrupado = contas.reduce((acc, conta) => {
      const data = new Date(conta.dataVencimento);
      const mesNome = meses[data.getMonth()] + ' ' + data.getFullYear();

      if (!acc[mesNome]) {
        acc[mesNome] = { mes: mesNome, total: 0, contas: [], mesIndex: data.getMonth(), ano: data.getFullYear() };
      }

      acc[mesNome].contas.push(conta);
      acc[mesNome].total += conta.valor;
      return acc;
    }, {});

    return Object.values(agrupado).sort((a: any, b: any) => {
      if (a.ano !== b.ano) return a.ano - b.ano;
      return a.mesIndex - b.mesIndex;
    });
  }

  abrirModalNovaConta() {
    this.novaConta = {
      descricao: '',
      valor: 0,
      dataVencimento: '',
      tipoConta: 1,
      categoria: 0
    };
    this.modalNovaConta = true;
  }

  fecharModal() {
    this.modalNovaConta = false;
    this.modalPagarConta = false;
    this.modalDeletarConta = false;
  }

  salvarConta() {
    if (this.novaConta.id) {
      this.financeiroService.alterarConta(this.novaConta).subscribe(response => {
        if (response.sucesso) {
          this.toastr.success('Conta a pagar alterada com sucesso!');
          this.carregarContas();
          this.fecharModal();
        } else {
          this.toastr.error(response.errors[0]?.mensagem || 'Erro ao alterar conta a pagar');
        }
      }, error => {
        this.toastr.error('Erro de conexão ao alterar conta a pagar');
      });
    } else {
      this.financeiroService.salvarContaAPagar(this.novaConta).subscribe(response => {
        if (response.sucesso) {
          this.toastr.success('Conta a pagar salva com sucesso!');
          this.carregarContas();
          this.fecharModal();
        } else {
          this.toastr.error(response.errors[0]?.mensagem || 'Erro ao salvar conta a pagar');
        }
      }, error => {
        this.toastr.error('Erro de conexão ao salvar conta a pagar');
      });
    }
  }

  pagarConta(conta: any) {
    this.pagamento = {
      dataPagamento: new Date().toISOString().split('T')[0],
      valor: conta.valor,
      conta: conta
    };
    this.modalPagarConta = true;
  }

  confirmarPagamento() {
    if (!this.pagamento.conta) return;

    const request: BaixarConta = {
      usuario: this.authService.AccessToken?.nome || '',
      contaId: this.pagamento.conta.id,
      valor: this.pagamento.valor,
      data: new Date(this.pagamento.dataPagamento).toISOString()
    };

    this.financeiroService.baixarContaAPagar(request).subscribe(response => {
      if (response.sucesso) {
        if (response.errors && response.errors.length > 0) {
          this.toastr.error(response.errors[0]?.mensagem || 'Erro ao realizar pagamento');
        } else {
          this.toastr.success('Pagamento realizado com sucesso!');
          this.carregarContas();
          this.fecharModal();
        }
      } else {
        this.toastr.error(response.errors[0]?.mensagem || 'Erro ao realizar pagamento');
      }
    }, error => {
      this.toastr.error('Erro de conexão ao realizar pagamento');
    });
  }

  alterarConta(conta: any) {
    this.financeiroService.obterContaPorId(conta.id).subscribe(response => {
      if (response.sucesso) {
        this.novaConta = {
          ...response.dados,
          dataVencimento: response.dados.dataVencimento ? response.dados.dataVencimento.split('T')[0] : ''
        };
        this.modalNovaConta = true;
      } else {
        this.toastr.error('Erro ao buscar detalhes da conta');
      }
    });
  }

  deletarConta(conta: any) {
    this.contaParaDeletar = conta;
    this.modalDeletarConta = true;
  }

  confirmarDelecao() {
    if (!this.contaParaDeletar) return;

    this.financeiroService.deletarConta(this.contaParaDeletar.id).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success('Conta deletada com sucesso!');
        this.carregarContas();
        this.fecharModal();
      } else {
        this.toastr.error(response.errors[0]?.mensagem || 'Erro ao deletar conta');
      }
    }, error => {
      this.toastr.error('Erro de conexão ao deletar conta');
    });
  }
}
